import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';

interface InstallationShare {
    connectionId: string;
    tenantId: string;
    installationId: string;
    sourceTenantId: string;
    sharedAt: string;
    sharedBy: string;
    isActive: boolean;
}

interface InstallationSharesResponse {
    success: boolean;
    shares: InstallationShare[];
}

export const useGitHubInstallationShares = (connectionId: string) => {
    const apiClient = useApiClient();

    return useQuery<InstallationSharesResponse>({
        queryKey: ['githubInstallationShares', connectionId],
        queryFn: async () => {
            const response = await apiClient.get(`/github/installations/${connectionId}/shares`);
            if (!response.ok) {
                throw new Error('Failed to fetch installation shares');
            }
            return response.json();
        },
        enabled: !!connectionId,
    });
};

export const useDeleteGitHubInstallationShare = () => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ connectionId, tenantId }: { connectionId: string; tenantId: string }) => {
            const response = await apiClient.delete(`/github/installations/${connectionId}/shares/${tenantId}`);
            if (!response.ok) {
                throw new Error('Failed to delete installation share');
            }
        },
        onSuccess: (_, { connectionId }) => {
            queryClient.invalidateQueries({ queryKey: ['githubInstallationShares', connectionId] });
        },
    });
};